import React from 'react';
import moment from 'moment';
import swal from 'sweetalert';
import swal2 from 'sweetalert2';
import shortid from 'shortid';
import DatePicker from 'react-datepicker';
import { spmfcloudFunctionUrl } from '../../../actions/salesforces';
import { getApplicationBeneList } from '../Application/actions';
import { encryptQuery } from '../../../utils/common';
import { fetchQueryData } from '../../../utils/sf-request';

export const describeFundRequestObject = () => (
    async (dispatch, getState) => {
        // if (getState().objectInfo.Person__c.length > 0) return;
        const result = await fetch(`${spmfcloudFunctionUrl}/sobject/Receipt__c/describe`, {
            mode: 'cors',
            cache: 'no-cache',
            method: 'GET',
            headers: {
                'hash-token': getState().user.siteToken.hash,
                'Content-Type': 'application/json',
            },
        }).then(response => response.json());
        dispatch({
            type: 'RECEIPT_DESCRIBE',
            payload: result.result.fields || {},
        });
    }
);

export function massUpdateColumns() {
    const rows = [
        {
            Header: 'No.',
            Cell: columnProps => columnProps.index + 1,
        },
        {
            accessor: 'Application_No__c',
            Header: 'Application No.',
        },
        {
            id: 'beneficiaryName',
            accessor: a => a.Beneficiary__r.Name,
            Header: 'Beneficiary Name',
        },
        {
            id: 'idNumber',
            accessor: a => a.Beneficiary__r.ID_Number__c,
            Header: 'ID Number',
        },
        {
            accessor: 'Approved_Amount__c',
            Header: 'Approved Amount',
        },
        {
            accessor: 'Approved_Amount__c',
            Header: 'Given Amount',
            Cell: columnProps => (
                <input
                    value={this.props.massReceiptUpdates[columnProps.index] ? this.props.massReceiptUpdates[columnProps.index].Given_Amount__c : ''}
                    type="number"
                    min="0"
                    max={columnProps.value}
                    className="form-control"
                    onChange={(e) => {
                        const { massReceiptUpdates } = this.props;
                        massReceiptUpdates[columnProps.index].Given_Amount__c = e.target.value;
                        // this.setState({ massReceiptUpdates });
                        this.props.updateMass(massReceiptUpdates);
                    }}
                />
            ),
        },
        {
            accessor: 'Date_Received__c',
            Header: 'Date Received',
            Cell: columnProps => (
                <DatePicker
                    selected={this.props.massReceiptUpdates[columnProps.index] ? this.props.massReceiptUpdates[columnProps.index].Date_Received__c : moment()}
                    onChange={(value) => {
                        const { massReceiptUpdates } = this.props;
                        massReceiptUpdates[columnProps.index].Date_Received__c = value;
                        // this.setState({ massReceiptUpdates });
                        this.props.updateMass(massReceiptUpdates);
                    }}
                    dateFormat="DD/MM/YYYY"
                    className="form-control"
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                />
            ),
        },
        {
            accessor: 'Mode_of_Payment__c',
            Header: 'Mode of Payment',
            Cell: columnProps => (
                <select
                    className="form-control"
                    onChange={(e) => {
                        const { massReceiptUpdates } = this.props;
                        massReceiptUpdates[columnProps.index].Mode_of_Payment__c = e.target.value;
                        if (e.target.value === 'Cash') {
                            massReceiptUpdates[columnProps.index].Cheque_Transaction_No__c = '';
                        }
                        // this.setState({ massReceiptUpdates });
                        this.props.updateMass(massReceiptUpdates);
                    }}
                    value={this.props.massReceiptUpdates[columnProps.index] ? this.props.massReceiptUpdates[columnProps.index].Mode_of_Payment__c : ''}
                >
                    <option value="">-</option>
                    <option value="Cash">Cash</option>
                    <option value="Cheque">Cheque</option>
                    <option value="Giro">Giro</option>
                </select>
            ),
        },
        {
            accessor: 'Cheque_Transaction_No__c',
            Header: 'Cheque/Transaction No.',
            Cell: (columnProps) => {
                let value = '';
                let isRequired = false;
                let isDisabled = false;

                if (this.props.massReceiptUpdates[columnProps.index]) {
                    value = this.props.massReceiptUpdates[columnProps.index].Cheque_Transaction_No__c;
                    if (this.props.massReceiptUpdates[columnProps.index].Mode_of_Payment__c === 'Cash') {
                        isDisabled = true;
                        isRequired = false;
                    } else {
                        isDisabled = false;
                        isRequired = true;
                    }
                }

                return (
                    <input
                        value={value}
                        maxLength="20"
                        type="text"
                        className="form-control"
                        required={isRequired}
                        disabled={isDisabled}
                        onChange={(e) => {
                            const { massReceiptUpdates } = this.props;
                            massReceiptUpdates[columnProps.index].Cheque_Transaction_No__c = e.target.value;
                            // this.setState({ massReceiptUpdates });
                            this.props.updateMass(massReceiptUpdates);
                        }}
                    />
                );
            },
        },
    ];

    return rows;
}

export function receiptColumn() {
    const { loggedInUser } = this.props.user;
    const { selectedReceipt } = this.state;
    const rows = [loggedInUser.Partner_Authority__c !== null ? {
        Header: <input type="checkbox" onChange={this.toggleCheckedList} />,
        accessor: 'Id',
        Cell: propsCol => (propsCol.row.Status__c === 'Disbursed' ? (<input type="checkbox" checked={selectedReceipt.indexOf(propsCol.value) > -1} value={propsCol.value} onChange={this.toggleCheckedList} />) : null),
        filterable: false,
        width: 40,
    } : <input type="checkbox" onChange={this.toggleCheckedList} />, {
        accessor: 'Application_No__c',
        Header: 'Application No',
    }, {
        id: 'BeneficiaryName',
        accessor: a => a.Beneficiary__r.Name,
        Header: 'Beneficiary Name',
    }, {
        Header: 'Receipt No',
        accessor: 'Name',
    }, {
        Header: 'Approved Amount',
        accessor: 'Approved_Amount__c',
        filterMethod: (filter, row) => {
            const pattern = new RegExp(filter.value);
            if (pattern.test(`${row.Approved_Amount__c}`)) return row;
        },
    }, {
        accessor: 'Scheduled_Payout_Date__c',
        Header: 'Schedule Payout Date',
        Cell: columnProps => moment(columnProps.value).format('DD-MMM-YYYY'),
        filterMethod: (filter, row) => {
            if (moment(row.Scheduled_Payout_Date__c).format('DD-MMM-YYYY').indexOf(filter.value) !== -1) return row;
        },
    }, {
        accessor: 'Given_Amount__c',
        Header: 'Given Amount',
        filterMethod: (filter, row) => {
            const pattern = new RegExp(filter.value);
            if (pattern.test(`${row.Given_Amount__c}`)) return row;
        },
    }, {
        accessor: 'Status__c',
        Header: 'Status',
        Filter: ({ filter, onChange }) => {
            return (
                <select
                    onChange={event => onChange(event.target.value)}
                    value={filter ? filter.value : ''}
                >
                    <option value="">All</option>
                    {this.props.receiptStatusList.map(status => (
                        <option key={shortid.generate()} value={status.value}>{status.label}</option>
                    ))}
                </select>
            );
        },
    },
    {
        accessor: 'Id',
        Header: 'Actions',
        minWidth: 250,
        filterable: false,
        sortable: false,
        Cell: (columnProps) => {
            const buttons = [];
            buttons.push(
                <button
                    className="btn btn-default btn-sm"
                    disabled={columnProps.row.Status__c !== 'Disbursed'}
                    key={shortid.generate()}
                    onClick={() => {
                        this.selectReceipt(columnProps.value);
                        this.setState({
                            modalReceive: true,
                            modalData: {
                                Given_Amount__c: columnProps.row.Approved_Amount__c,
                                Date_Received__c: moment(),
                                Mode_of_Payment__c: 'Cash',
                            },
                        });
                    }}
                >
                    <i className="fa fa-paper-plane" />
                    Receive
                </button>,
                <button
                    key={shortid.generate()}
                    className="btn btn-warning btn-fill btn-sm"
                    onClick={() => this.changeStatus('Cancelled', columnProps.value)}
                >
                    <i className="fa fa-times" />
                    Cancel
                </button>,
                <button
                    key={shortid.generate()}
                    className="btn btn-info btn-fill btn-sm"
                    onClick={() => this.setState({ selectedId: columnProps.row.Id, modalHistory: true })}
                >
                    <i className="fa fa-history" />
                    History
                </button>,
            );
            return (
                <div className="btn-group" role="group" aria-label="...">
                    {buttons}
                </div>
            );
        },
    }];
    // removing last button index for household user
    if (this.props.user.loggedInUser.Partner_Authority__c === null) {
        rows.splice(0, 1);
        rows.splice(-1, 1);
    }
    return rows;
}
export async function getAllReceipt() {
    const { user } = this.props;
    // fetching the beneficiers data
    let query = '';
    if (this.props.user.loggedInUser.Partner_Authority__c !== null) {
        query = `Select Id, Name, Application_No__c, Approved_Amount__c, Beneficiary__c, Beneficiary__r.Name, Beneficiary__r.Education_Level__c, Beneficiary__r.ID_Number__c,
        Date_Approved__c, Date_Received__c, Status__c, Mode_of_Payment__c, Given_Amount__c, Scheduled_Payout_Date__c
        from Receipt__c where Issued_By__c = '${this.props.user.loggedInUser.Account.Id}' ORDER BY Status__c ASC, LastModifiedDate DESC`;
    } else {
        const data = await getApplicationBeneList(this.props.user.loggedInUser.Account.Id, this.props.user.siteToken.hash, this.props.user.key);
        let beneIds = '';
        for (let i = 0; i < data.records.length; i++) {
            beneIds += `'${data.records[i].Id}',`;
        }
        beneIds = beneIds.substring(0, beneIds.length - 1);
        // fetching the receipt data
        query = `Select Id, Name, Application_No__c, Approved_Amount__c, Beneficiary__c, Beneficiary__r.Name,
        Date_Approved__c, Date_Received__c, Status__c, Mode_of_Payment__c, Given_Amount__c, Scheduled_Payout_Date__c
        from Receipt__c WHERE Generated_From__c IN (${beneIds}) Order By Status__c, Scheduled_Payout_Date__c`;
    }
    const json = await fetchQueryData(query, user.siteToken.hash, user.key);
    return json;
}

export async function massUpdateReceipt() {
    const responses = this.state.selectedReceipt.map(async (receipt, index) => {
        const response = await fetch(`${spmfcloudFunctionUrl}/update-receipt`, {
            mode: 'cors',
            body: JSON.stringify({
                data: {
                    ...this.state.massReceiptUpdates[index],
                    Status__c: 'Received by Beneficiary',
                },
                selectedReceipt: [receipt],
            }),
            cache: 'no-cache',
            method: 'POST',
            headers: {
                'hash-token': this.props.user ? this.props.user.siteToken.hash : this.props.token,
                'Content-Type': 'application/json',
            },
        });

        const json = await response.json();
        if (!response.ok) {
            throw new Error(json.message);
        }

        return json;
    });

    await Promise.all(responses);

    return {
        message: 'Done mass updating receipts',
    };
}

/**
 * Need to be bind with the main component
 */
export async function updateReceipt() {
    const json = await fetch(`${spmfcloudFunctionUrl}/update-receipt`, {
        mode: 'cors',
        body: JSON.stringify({
            data: {
                ...this.state.modalData,
                Status__c: 'Received by Beneficiary',
            },
            selectedReceipt: this.state.selectedReceipt,
        }),
        cache: 'no-cache',
        method: 'POST',
        headers: {
            'hash-token': this.props.user ? this.props.user.siteToken.hash : this.props.token,
            'Content-Type': 'application/json',
        },
    }).then(response => response.json());
    return json;
}

export async function changeStatus(status, id) {
    if (this.state.loading) return;
    this.setState({ loading: true });
    const updatedData = {
        Id: id,
        Status__c: status,
    };
    swal2({
        title: 'Are you sure want to update this receipt?',
        text: "You won't be able to revert this action.",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
    }).then(async (dialog) => {
        if (dialog.value) {
            try {
                const result = await fetch(`${spmfcloudFunctionUrl}/sobject/Receipt__c`, {
                    mode: 'cors',
                    cache: 'no-cache',
                    method: 'PATCH',
                    body: JSON.stringify(updatedData),
                    headers: {
                        'hash-token': this.props.user.siteToken.hash,
                        'Content-Type': 'application/json',
                    },
                }).then((response) => {
                    if (!response.ok) throw (new Error(response.message));
                    return response.json();
                });
                await this.componentWillMount();
                this.setState({ loading: false });
                swal({
                    text: result.message,
                    title: 'Receipt update successfully',
                });
            } catch (error) {
                swal({
                    text: error.toString(),
                    title: 'An error occured when updating status',
                });
                this.setState({ loading: true });
            }
        }
        this.setState({ loading: false });
    });
}
export default null;



//////////////////
// WEBPACK FOOTER
// ./src/components/Portal/Receipt/actions.js
// module id = 136
// module chunks = 0